import { render, staticRenderFns } from "./PannelFour.vue?vue&type=template&id=7bec05d8&scoped=true&"
import script from "./PannelFour.vue?vue&type=script&lang=js&"
export * from "./PannelFour.vue?vue&type=script&lang=js&"
import style0 from "./PannelFour.vue?vue&type=style&index=0&id=7bec05d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec05d8",
  null
  
)

export default component.exports